import ServiceError from './ServiceError';

class ServiceForbidden extends ServiceError {
  constructor(error, message = "You don't have access to this resource") {
    super(error, message);
  }
}

export default ServiceForbidden;
